import { useState, useEffect } from "react";
import { useWaitlist } from "@/context/WaitlistContext";

export default function Header() {
  const { joined } = useWaitlist();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[hsl(270_18%_4%/0.88)] backdrop-blur-xl border-b border-violet-500/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
        <button
          type="button"
          data-testid="header-logo"
          className="flex items-center gap-2 cursor-pointer rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="ReachMeNow, back to top"
        >
          <span className="text-lg font-bold tracking-tight bg-gradient-to-r from-white via-violet-200 to-violet-400 bg-clip-text text-transparent">ReachMeNow</span>
        </button>

        <nav className="hidden md:flex items-center gap-8" aria-label="Page sections">
          <button
            type="button"
            data-testid="nav-features"
            onClick={() => scrollToSection("features")}
            className="text-sm text-white/55 hover:text-violet-200 transition-colors duration-200 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            Features
          </button>
          <button
            type="button"
            data-testid="nav-how-it-works"
            onClick={() => scrollToSection("solution")}
            className="text-sm text-white/55 hover:text-violet-200 transition-colors duration-200 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            How it works
          </button>
          <button
            type="button"
            data-testid="nav-demo"
            onClick={() => scrollToSection("demo")}
            className="text-sm text-white/55 hover:text-violet-200 transition-colors duration-200 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            Demo
          </button>
          <button
            type="button"
            data-testid="nav-creator-pov"
            onClick={() => scrollToSection("creator-pov")}
            className="text-sm text-white/55 hover:text-violet-200 transition-colors duration-200 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            Your alerts
          </button>
        </nav>

        <button
          type="button"
          data-testid="header-cta-button"
          onClick={() => scrollToSection("hero-email")}
          className={
            joined
              ? "text-sm font-medium rounded-full px-5 py-2 border border-violet-400/35 bg-violet-500/10 text-violet-200/90 hover:bg-violet-500/15 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              : "bg-gradient-to-r from-violet-500 to-fuchsia-500 text-white text-sm font-medium rounded-full px-5 py-2 shadow-lg shadow-violet-600/25 hover:from-violet-400 hover:to-fuchsia-400 transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          }
        >
          {joined ? "On the waitlist" : "Get Early Access"}
        </button>
      </div>
    </header>
  );
}
